import React from 'react';
import { useField } from 'formik';
import Select from '@material-ui/core/Select/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import classes from './FormikField.module.scss';

export const MultipleSelectField = ({
    onChangeCallback,
    label,
    className,
    InputProps,
    select,
    form: { values },
    field: { name },
    variant,
    ...props
}) => {
    const [input, meta, helpers] = useField({ name, ...props });
    const { error } = meta;
    const { setValue } = helpers;

    return (
        <FormControl
            variant={variant}
            className={className}
            error={Boolean(error) ?? false}
        >
            <InputLabel htmlFor={name}>{label}</InputLabel>
            <Select
                variant={variant}
                label={label}
                {...input}
                {...props}
                MenuProps={{
                    classes: {
                        paper: classes.selectMenuPaper,
                        list: classes.selectMenuList,
                    },
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                    },
                    getContentAnchorEl: null,
                }}
                onChange={event => {
                    const { value } = event.target;
                    setValue(value);
                    if (onChangeCallback != null) {
                        onChangeCallback({
                            ...values,
                            [name]: value,
                        });
                    }
                }}
            />
            {error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
    );
};
